/**
 * AdvanceInvoices API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createAdvanceInvoice,
  createCustomAdvanceInvoice,
  getAdvanceInvoiceById,
  getAdvanceInvoices,
  getAdvanceInvoiceVersion,
  getAdvanceInvoiceVersions,
  getShareableAdvanceInvoice,
  getShareableAdvanceInvoiceHtml,
  getShareableAdvanceInvoicePdf,
  renderAdvanceInvoicePreview,
  updateAdvanceInvoice,
  voidAdvanceInvoice,
} from "../generated/advance-invoices/advance-invoices";

import { wrapListMethod, wrapMethod } from "./utils";

export const advanceInvoices = {
  /** @see getShareableAdvanceInvoice */
  getShareableAdvanceInvoice: wrapMethod(getShareableAdvanceInvoice),

  /** @see getShareableAdvanceInvoiceHtml */
  getShareableAdvanceInvoiceHtml: wrapMethod(getShareableAdvanceInvoiceHtml),

  /** @see getShareableAdvanceInvoicePdf */
  getShareableAdvanceInvoicePdf: wrapMethod(getShareableAdvanceInvoicePdf),

  /** @see createAdvanceInvoice */
  create: wrapMethod(createAdvanceInvoice),

  /** @see getAdvanceInvoices */
  list: wrapListMethod(getAdvanceInvoices),

  /** @see createCustomAdvanceInvoice */
  createCustom: wrapMethod(createCustomAdvanceInvoice),

  /** @see getAdvanceInvoiceById */
  get: wrapMethod(getAdvanceInvoiceById),

  /** @see updateAdvanceInvoice */
  update: wrapMethod(updateAdvanceInvoice),

  /** @see getAdvanceInvoiceVersions */
  getVersions: wrapMethod(getAdvanceInvoiceVersions),

  /** @see getAdvanceInvoiceVersion */
  getVersion: wrapMethod(getAdvanceInvoiceVersion),

  /** @see renderAdvanceInvoicePreview */
  renderAdvanceInvoicePreview: wrapMethod(renderAdvanceInvoicePreview),

  /** @see voidAdvanceInvoice */
  void: wrapMethod(voidAdvanceInvoice),
} as const;

export type AdvanceInvoicesApi = typeof advanceInvoices;
